import jsonApiClient from '../../utils/jsonApiClient'
import LandingPageContainer from '../../components/LandingPageContainer'
import TutorSearchResultsList from '../../components/TutorSearchResultsList'
import LandingPageHead from '../../components/LandingPageHead'

export async function getStaticProps({params}) {
  const slug = params.slug.join('/')

  const jsonApi = jsonApiClient()
  const pageArray = await jsonApi.findAll('page', {
    filter: {
      slug: `${slug}/`
    },
    include: 'children,ancestors,subject,level,marketing-location'
  })

  const page = pageArray.data[0]

  const tutorSearchResults = await jsonApi.findAll('tutor-profile', {
    filter: {
      query: {
        subject: page.subject?.slug,
        level: page.level?.slug,
        lat: page.marketingLocation?.lat,
        lon: page.marketingLocation?.lon
      },
      employee_review_status: 'approved',
      only_available: true
    },
    include: 'subjects,subject-levels,subject-levels.subject,subject-levels.level',
    page: {
      size: 10
    }
  })

  return {
    props: {
      page,
      tutorSearch: {
        results: tutorSearchResults.data,
        meta: tutorSearchResults.meta
      }
    },
    revalidate: 60
  }
}

export async function getStaticPaths() {
  const jsonApi = jsonApiClient('page')
  const { data } = await jsonApi.findAll('page', {
    filter: {
      exclude_slug: ['subjects', 'locations']
    },
    page: {
      size: 1000
    }
  })

  return {
    paths: data.map((page) => ({
      params: { slug: page.slug.split('/') }
    })),
    fallback: "blocking"
  }
}

function TutoringShow({page, tutorSearch}) {
  const { results: tutorSearchResults, meta: tutorSearchMeta } = tutorSearch
  const tutorSearchRecordCount = tutorSearchMeta['record-count']
  const hasSearchResults = tutorSearchRecordCount > 0

  return (
    <>
      <LandingPageHead page={page} />
      <LandingPageContainer page={page}>
        {page.showSearchResults && hasSearchResults &&
          <div className="mb-5">
            <p className="fw-bold">
              {tutorSearchRecordCount}
              {' '}
              {page.level?.name}
              {' '}
              {page.subject?.name}
              {' '}
              tutors available.
            </p>

            <p>Here are some of the top {page.level?.name} {page.subject?.name} tutors.</p>

            <TutorSearchResultsList results={tutorSearchResults} subject={page.subject} level={page.level}/>
          </div>
        }
      </LandingPageContainer>
    </>
  )
}

export default TutoringShow
